import Modal from './modal'

export const AmuiModal = Modal

export default Vue => Vue.component(Modal.name, Modal)
